var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"observaciones"},[_c('input-comp',{attrs:{"label":"Observaciones"},model:{value:(_vm.observacion),callback:function ($$v) {_vm.observacion=$$v},expression:"observacion"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }